import React from 'react';
import '../styles/gallery.css'
import One1 from '../../img/harrison hotel/one/One1.jpg';
import One2 from '../../img/harrison hotel/one/One2.jpg';
import One3 from '../../img/harrison hotel/one/One3.jpg';
import One4 from '../../img/harrison hotel/one/One4.jpg';
import One5 from '../../img/harrison hotel/one/One5.jpg';
import One6 from '../../img/harrison hotel/one/One6.jpg';
import One7 from '../../img/harrison hotel/one/One7.jpg';
import One8 from '../../img/harrison hotel/one/One8.jpg';
import Two1 from '../../img/harrison hotel/two beds/Two1.jpg';
import Two2 from '../../img/harrison hotel/two beds/Two2.jpg';
import Two3 from '../../img/harrison hotel/two beds/Two3.jpg';
import Two4 from '../../img/harrison hotel/two beds/Two4.jpg';
import Two5 from '../../img/harrison hotel/two beds/Two5.jpg';
import Two6 from '../../img/harrison hotel/two beds/Two6.jpg';
import Two7 from '../../img/harrison hotel/two beds/Two7.jpg';
import Two8 from '../../img/harrison hotel/two beds/Two8.jpg';
import Two9 from '../../img/harrison hotel/two beds/Two9.jpg';
import Two10 from '../../img/harrison hotel/two beds/Two10.jpg';
import King1 from '../../img/harrison hotel/king/King1.jpg';
import King2 from '../../img/harrison hotel/king/King2.jpg';
import King3 from '../../img/harrison hotel/king/King3.jpg';
import King4 from '../../img/harrison hotel/king/King4.jpg';
import Common1 from '../../img/harrison hotel/Common1.jpg';
import Common2 from '../../img/harrison hotel/Common2.jpg';
import Common3 from '../../img/harrison hotel/Common3.jpg';
import Common4 from '../../img/harrison hotel/Common4.jpg';
import Common5 from '../../img/harrison hotel/Common5.jpg';
import Common6 from '../../img/harrison hotel/Common6.jpg';
import Common7 from '../../img/harrison hotel/Common7.jpg';
import Common8 from '../../img/harrison hotel/Common8.jpg';
import Common9 from '../../img/harrison hotel/Common9.jpg';
import Common10 from '../../img/harrison hotel/Common10.jpg';
import Common11 from '../../img/harrison hotel/Common11.jpg';
import Common12 from '../../img/harrison hotel/Common12.jpg';
import Common13 from '../../img/harrison hotel/Common13.jpg';
import Common14 from '../../img/harrison hotel/Common14.jpg';
const Galery = () => {
    return (
        <div className='galeria '>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common1} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common2} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common3} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common4} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common5} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common6} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common7} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common8} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common9} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common10} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common11} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common12} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common13} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Common14} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={One1} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={One2} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={One3} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={One4} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={One5} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={One6} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={One7} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={One8} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Two1} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Two2} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Two3} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Two4} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Two5} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Two6} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Two7} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Two8} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Two9} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={Two10} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={King1} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={King2} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={King3} alt="" className=' image'/>
            </div>
            <div className='col-sm-12 col-md-6 col-lg-4 box'>
                <img src={King4} alt="" className=' image'/>
            </div>
        </div>
    );
};

export default Galery;